import { gql } from 'graphql-query-contracts';

export const removeTenant = gql(`
  mutation RemoveTenant(
    $propertyId: UUID!
    $unitId: String!
    $tenantId: UUID!
  ) {
    removeTenant(propertyId: $propertyId, unitId: $unitId, tenantId: $tenantId)
  }
`);
